import React from 'react';
import './InvestorRelations.css';

const InvestorRelations = () => {
  const marketData = {
    standardPP: { percentage: 60, label: 'Standard PP Woven Bags' },
    fibc: { percentage: 20, label: 'FIBC' },
    bopp: { percentage: 12, label: 'BOPP Laminated Bags' },
    ppFabric: { percentage: 8, label: 'PP Fabric' }
  };

  const capacityData = [
    { label: 'Installed Capacity (Volume in MT)', value: '6,800', type: 'capacity' },
    { label: 'Average Production (Volume in MT)', value: '7,600', type: 'production' },
    { label: 'Average Capacity Utilisation', value: '95.0%', type: 'utilization' },
    { label: 'Historical Data (2024)', value: '4,250 MT Installed, 2,500 MT Production, 49.6% Utilisation', type: 'historical' }
  ];

  const swotData = {
    strengths: [
      'Cost-Effectiveness',
      'Durability',
      'State of art production facility',
      'Quality Assurance and Standards'
    ],
    opportunities: [
      'BOPP Demand',
      'Expanding new geographical area',
      'FIBC Exports potential'
    ],
    weaknesses: [
      'Heavy dependence on raw material suppliers',
      'High working capital requirement'
    ],
    threats: [
      'Increased Competition from Big Players',
      'Regulatory Changes (SUP bans)'
    ]
  };

  const strategicDrivers = [
    {
      title: 'Digital Public Infrastructure (DPI)',
      description: 'UPI alone processes billions of transactions, rapidly formalizing the economy.',
      icon: 'fas fa-mobile-alt'
    },
    {
      title: 'PLI Scheme Success',
      description: 'The Production Linked Incentive scheme is attracting FDI and strengthening domestic manufacturing.',
      icon: 'fas fa-chart-line'
    },
    {
      title: 'Favorable Demographics',
      description: 'The world\'s largest working-age population underpins a powerful consumption-driven growth model.',
      icon: 'fas fa-users'
    }
  ];

  return (
    <section id="investor" className="investor-relations section">
      <div className="container">
        <div className="section-header text-center">
          <h2 className="section-title">Investment Thesis: Market Leadership and Growth Drivers</h2>
          <p className="section-subtitle">
            Strategic positioning in India's growing packaging industry
          </p>
        </div>

        <div className="market-opportunity">
          <h3>Market Opportunity & Positioning</h3>
          <div className="market-content">
            <div className="market-share">
              <h4>India PP Woven Market Share (Volume)</h4>
              <div className="market-chart">
                {Object.entries(marketData).map(([key, data]) => (
                  <div key={key} className="market-segment">
                    <div className="segment-bar">
                      <div 
                        className="segment-fill" 
                        style={{ width: `${data.percentage}%` }}
                      ></div>
                    </div>
                    <div className="segment-label">
                      <span className="percentage">{data.percentage}%</span>
                      <span className="label">{data.label}</span>
                    </div>
                  </div>
                ))}
              </div>
              <p className="market-note">
                Our core product, Standard PP Woven Bags, represents the largest segment. 
                BOPP Laminated Bags are the high-growth segment.
              </p>
            </div>
          </div>
        </div>

        <div className="strategic-drivers">
          <h3>Strategic Drivers</h3>
          <div className="drivers-grid">
            {strategicDrivers.map((driver, index) => (
              <div key={index} className="driver-card">
                <div className="driver-icon">
                  <i className={driver.icon}></i>
                </div>
                <h4>{driver.title}</h4>
                <p>{driver.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="capacity-section">
          <h3>Operational Efficiency and Capacity Utilisation</h3>
          <div className="capacity-content">
            <div className="capacity-table">
              {capacityData.map((item, index) => (
                <div key={index} className="capacity-row">
                  <div className="capacity-label">{item.label}</div>
                  <div className={`capacity-value ${item.type}`}>{item.value}</div>
                </div>
              ))}
            </div>
            <div className="utilization-gauge">
              <div className="gauge-container">
                <div className="gauge-circle">
                  <div className="gauge-fill" style={{ '--percentage': '95%' }}></div>
                  <div className="gauge-text">
                    <span className="gauge-number">95.0%</span>
                    <span className="gauge-label">Utilization</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="swot-analysis">
          <h3>Strategic Analysis: Strengths, Opportunities, and Mitigants</h3>
          <div className="swot-grid">
            <div className="swot-category strengths">
              <h4>Strengths</h4>
              <ul>
                {swotData.strengths.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
            <div className="swot-category opportunities">
              <h4>Opportunities</h4>
              <ul>
                {swotData.opportunities.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
            <div className="swot-category weaknesses">
              <h4>Weaknesses</h4>
              <ul>
                {swotData.weaknesses.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
            <div className="swot-category threats">
              <h4>Threats</h4>
              <ul>
                {swotData.threats.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InvestorRelations;
